<dx-menu [items]="items"
         [disabled]="disabled"
         [orientation]="orientation"
         [showFirstSubmenuMode]="showOnHover ? { name: 'onHover', delay: 0 } : { name: 'onClick', delay: { show: 50, hide: 300 } }"
         [hideSubmenuOnMouseLeave]="showOnHover"
         (onSubmenuShowing)="visibleChanged.emit(true)"
         (onSubmenuHidden)="onSubmenuHidden($event)"
         [focusStateEnabled]="false"
         (onItemClick)="onItemClick($event)"
         (onSubmenuShown)="onSubmenuShown($event)">
    <div *dxTemplate="let item of 'item'"
         class="d-flex align-items-center gap-2"
         [ngClass]="{
            'separator-top': item.separator || item.separatorTop,
            'separator-bottom': item.separatorBottom,
            'p-2': item.padding !== false,
            'p-0': item.padding === false,
        }"
         [attr.data-tour]="item.text">
        <ng-container [ngTemplateOutlet]="item.templateRef ?? defaultTemplate"
                      [ngTemplateOutletContext]="{ $implicit: item }"> </ng-container>

        <ng-template #defaultTemplate>
            @if (useCheckbox(item)) {
                <dx-check-box [(value)]="item.isChecked"
                              [disabled]="item.disabled"
                              (onValueChanged)="onCheckboxValueChanged($event, item)"></dx-check-box>
            } @else if (item.icon) {
                <i [ngClass]="item.icon"></i>
            }

            @if (item.templateType) {
                <!-- div here as ng-container cannot have attributes.
        Need templateId to relate where to inject the template type as there can be plenty
        (e.g. 1 component instance corresponding to each person)-->
                <div #templateContainer
                     [attr.templateId]="item.templateId"
                     class="d-none"></div>
            } @else {
                @if (item.text) {
                    <span [adaptTooltip]="item.tooltip"
                          class="ms-1">{{ item.text }}</span>
                }
            }
        </ng-template>
    </div>
</dx-menu>
